<template>
  <v-dialog
      v-model="dialog"
      :width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on" class="mt-n5 mx-1" dark :color="getEventColor">
        <span :class=getEventClass>{{ getEventClassName }}</span>
        <span>{{ getEventName }}</span>
      </v-btn>
    </template>
    <v-container fluid>
      <v-card
          class="py-3 px-3"
      >
        <v-card-title class="justify-center">
          {{ getEventName }}
        </v-card-title>
        <v-form
          ref="form"
          v-model="form"
          class="pa-4 pt-6"
        >
          <v-row>
            <v-col cols="12" v-if="userId === null">
              <v-autocomplete
                  :rules="[rules.required]"
                  v-model="localItem.user.id"
                  :items="userList"
                  label="User"
                  clearable
                  hint="Enter users name or employee number"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="7">
              <v-text-field
                  :rules="[rules.required]"
                  label="Date start"
                  type="datetime-local"
                  v-model="localItem.event_start"
                  :value="localItem.event_start"
                  hint="Enter events date start"
                  :max="current_datetime"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  :rules="[rules.required]"
                  label="Duration"
                  type="time"
                  v-model="localItem.duration"
                  hint="Enter events duration"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="Comment"
                v-model="localItem.comment"
                hint="Enter events comment (min 5, max 50 chars)"
                counter="50"
                clearable
                :rules="[rules.min(5), rules.max(50), rules.required]"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              :disabled="!form"
              text
              @click="onAdd"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import Moment from "moment";

export default {
  name: 'TimeTrackerNewDialogTime',
  props: {
    length: {default: null},
    disabled: {default: false},
    event: {type: String, default: 'NoName'},
    userId: {default: null},
  },

  computed: {
    ...mapGetters('TimeTracker', ['getColumns',]),
    ...mapFields('TimeTracker', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('HumanUser', {itemListHuman: 'itemList'},),

    userList() {
      let user_list = []
      for (let row of this.itemListHuman)
        if (row.active)
          user_list.push({
            text: row.user + '(' + row.employee_number + ')',
            value: row.id
          })
      return user_list
    },

    getEventColor() {
      return this.local_phrase[this.event].color
    },
    getEventClass() {
      return "material-icons " + this.local_phrase[this.event].class
    },
    getEventClassName() {
      return this.local_phrase[this.event].class
    },
    getEventName() {
      return this.local_phrase[this.event].de
    },
    current_datetime() {
      const dt =  Moment().format('YYYY-MM-DDTHH:mm')
      // console.log('current_datetime', dt)
      return dt
    },

  },

  methods: {
    ...mapActions('TimeTracker', ['fetchSaveItemField']),
    ...mapActions('CalendarEvent', {'fetchItemListCalendar': 'fetchItemList'}),

    onAdd() {
      console.log('onAdd', this.localItem)
      let time = this.localItem.duration.split(':')
      let duration_msec = time[0] * 60 * 60 * 1000 + time[1] * 60 * 1000
      let event_start = new Date(this.localItem.event_start)
      let event_stop = new Date(event_start.getTime() + duration_msec)

      let fields_dict = {}
      fields_dict['event'] = this.localItem.event
      fields_dict['comment'] = this.localItem.comment
      fields_dict['event_start'] = event_start
      fields_dict['event_stop'] = event_stop
      fields_dict['user'] = {id: this.localItem.user.id}
      this.fetchSaveItemField({
        itemId: null,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'TimeTrackerEventDTO', from_consumer: 'TimeTrackerEventDTO'}
      })
      this.dialog = false
    },
  },

  mounted() {
    this.localItem.event = this.event
    this.localItem.user = {id: this.userId}
    this.localItem.event_start = this.current_datetime
  },

  data() {
    return {
      dialog: false,
      form: false,
      localItem: {
        user: {id: null},
        event: null,
        event_start: null,
        event_stop: null,
        duration: "00:00",
      },
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
      },
    }
  },
}

</script>


<style scoped lang="scss">

</style>